import { ItemTypeConsts } from 'client/util/Constants';

const ConfigurationAsidePanel = () => import('client/policies/ConfigurationAsidePanel.vue');
const OsManagementMainPanel = () => import('client/OsManagement/OsManagementMainPanel.vue');
const OsPatchManagementMainPanel = () => import('client/OsManagement/OsPatchManagementMainPanel.vue');
const PoliciesChooserAsidePanel = () => import('client/policies/PoliciesChooserAsidePanel.vue');

const osManagementProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.osPatchManagement,
  },
  mainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.osPatchManagement,
    isAsideOpen: false,
    itemType: ItemTypeConsts.osPatchManagement,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const osManagementTitle = 'OS Management';
const osPatchManagementTitle = 'OS Management';

export default [
  {
    path: '/osmanagement',
    name: 'osManagement',
    meta: { title: osManagementTitle },
    components: {
      mainPanel: OsManagementMainPanel,
    },
  },
  {
    path: '/osmanagement/patch',
    name: 'osPatchManagement',
    meta: {
      itemType: ItemTypeConsts.osPatchManagement,
      title: osPatchManagementTitle,
    },
    components: {
      mainPanel: OsPatchManagementMainPanel,
    },
    props: {
      mainPanel: osManagementProps.mainPanel,
    },
  },
  {
    path: '/osmanagement/patch/choose/:os?',
    name: 'newPatchPolicy',
    meta: {
      title: osPatchManagementTitle,
    },
    components: {
      mainPanel: OsPatchManagementMainPanel,
      asidePanel: PoliciesChooserAsidePanel,
    },
    props: {
      mainPanel: osManagementProps.mainPanel,
      asidePanel: route => ({
        ...osManagementProps.asidePanel,
        os: route.params.os,
      }),
    },
  },
  {
    path: '/osmanagement/patch/:id/details/:initialTabIndex?',
    name: 'osPatchManagementDetails',
    meta: { title: osPatchManagementTitle },
    components: {
      mainPanel: OsPatchManagementMainPanel,
      asidePanel: ConfigurationAsidePanel,
    },
    props: {
      mainPanel: osManagementProps.mainPanel,
      asidePanel: route => ({
        ...osManagementProps.asidePanel,
        itemId: route.params.id,
        initialTabIndex:
          route.params.initialTabIndex ? parseInt(route.params.initialTabIndex, 0) : 0,
      }),
    },
  },
  {
    path: '/osmanagement/patch/configure/:os/:templateId',
    name: 'osPatchManagementConfigure',
    meta: { title: osPatchManagementTitle },
    components: {
      mainPanel: OsPatchManagementMainPanel,
      asidePanel: ConfigurationAsidePanel,
    },
    props: {
      mainPanel: osManagementProps.mainPanel,
      asidePanel: route => ({
        ...osManagementProps.asidePanel,
        templateId: route.params.templateId,
        os: route.params.os,
      }),
    },
  },
];
